// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4900) return "static/chunks/4900-6726c363d07c9f3d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2342":"145f2ae54ecb0c75","3768":"be6d08ed40bb7ad6","7937":"d3c2e035198fdc9a"}[chunkId] + ".js";
};